import React from 'react';
import downloadIcon from '../../../pic/female-doctor-6810748_1920.png';
import chronoType from '../../../pic/chronotype.png';
import research from '../../../pic/research.png';
import './Body.css';
import { useTranslation } from 'react-i18next';

const Body = () => {
    const { t } = useTranslation();
    return (
        <>
            <div className="chronotype-section chronotype-section-1">
                <div className="chronotype-image">
                    <img src={chronoType} alt="Discover Your Chronotype" />
                </div>
                <div className="chronotype-content">
                    <h2>{t('body.discoverChronotype')}</h2>
                    <p>{t('body.discoverChronotypeDesc')}</p>
                    <button className="learn-more-btn">{t('body.learnMore')}</button>
                </div>
            </div>
            <div className="chronotype-section chronotype-section-2">
                <div className="chronotype-content">
                    <h2>{t('body.downloadApp')}</h2>
                    <p>{t('body.downloadAppDesc')}</p>
                    <button className="learn-more-btn">{t('body.learnMore')}</button>
                </div>
                <div className="chronotype-image-2">
                    <img src={downloadIcon} alt="Discover Your Chronotype" />
                </div>
            </div>
            <div className="chronotype-section chronotype-section-3">
                <div className="chronotype-image-3">
                    <img src={research} alt="Discover Your Chronotype" />
                </div>
                <div className="chronotype-content">
                    <h2>{t('body.researchInsights')}</h2>
                    <p>{t('body.researchInsightsDesc')}</p>
                    <button className="learn-more-btn">{t('body.learnMore')}</button>
                </div>
            </div>
        </>
    );
}

export default Body;
